import React from 'react';
import ChatSidePanelToggleButton from '../../common/chat/sidepanel/ChatSidePanelToggleButton';
import ChatSidePanelHeader from '../../common/chat/sidepanel/ChatSidePanelHeader';
import EventInfoSidePanelCard from '../../common/chat/sidepanel/EventInfoSidePanelCard';
import EventParticipantsSidePanelCard from '../../common/chat/members/EventParticipantsSidePanelCard';

export function EventChatSidePanel({
  isVisible,
  isOpen,
  onCollapse,
  onExpand,
  eventInfoProps,
  participantsPanelProps,
}) {
  if (!isVisible) return null;

  return (
    <aside
      className={`chat-side-panel side-panel admin-event-chat-side-panel${
        isOpen ? '' : ' chat-side-panel--collapsed'
      }`}
    >
      {isOpen ? (
        <>
          <ChatSidePanelHeader
            icon="fa-calendar-days"
            label="イベント情報"
            onCollapse={onCollapse}
          />
          <EventInfoSidePanelCard {...eventInfoProps} />

          <EventParticipantsSidePanelCard {...participantsPanelProps} />
        </>
      ) : (
        <div className="chat-side-panel__collapsed-rail">
          <ChatSidePanelToggleButton
            isOpen={false}
            onToggle={onExpand}
            label="イベント情報"
            iconOnly
            className="chat-side-panel__collapsed-toggle"
          />
        </div>
      )}
    </aside>
  );
}
